import React,{ Fragment} from 'react'
import { withRouteData } from 'react-static'
import { Helmet } from "react-helmet"

const NewsItem = withRouteData(({ n }) => {

  let uri = `https://afrodesiamedia.com/`
  let bgImg = {background: 'url('+ `${uri}` + n.featuredImage.path +') no-repeat center center'};

  // console.log(bgImg)

  return (

  <Fragment>
    <Helmet>
    <title> News/{n.permUrl} - afrodesiamedia</title>
      <link rel="shortcut icon" href="/favicon.ico" />
      <meta property="og:url" content="https://afrodesiamedia.com" />
      <meta property="og:title" content={n.permUrl} />
    </Helmet>
    <section className="news-item">
      <div className="item-bg" style={bgImg}>

      </div>
      <div className="news-article container">
        <h3>{n.newsTitle}</h3>
        <p className="date-wrap">
          <span className="date">{n.date}</span>
        </p>
        
        <article
          className="article-body" 
          dangerouslySetInnerHTML={{ __html: n.newsBody }} 
            />  
      </div>
    
    </section>
     
    </Fragment>
    
  )
})

export default NewsItem


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/News/components/NewsItem.js